import React, { Component } from "react";
import 'axios';
import Lines from '../AboutDir/Lines';
import './Service.css';
// import axios from "axios";

class Service extends Component {

    // state = {
    //     service : []
    // };

    // componentDidMount() {
    //     this.getService()
    // };

    // getService() {
    //     // axios
    // }

    render() {
        return (
            <div id="service">
                <h1 className="f2 fw5 black-80 athelas tc ttu">what i do</h1>
                <div className="tc lines">
                    <Lines />
                </div>
                <article class="center mw5 mw6-ns br3 hidden ba b--black-10 mv4">
                    <h1 class="f4 bg-near-white br3 br--top black-60 mv0 pv2 ph3">Frontend</h1>
                    <div class="pa3 bt b--black-10">
                        <p class="f6 f5-ns lh-copy measure fs-5" id="font">
                            As a Frontend developer i have experience in HTML 5, CSS 3, Bootstrap, Javascript, Django, and React.
                        </p>
                    </div>
                </article>
                <article class="center mw5 mw6-ns br3 hidden ba b--black-10 mv4">
                    <h1 class="f4 bg-near-white br3 br--top black-60 mv0 pv2 ph3">Backend</h1>
                    <div class="pa3 bt b--black-10">
                        <p class="f6 f5-ns lh-copy measure fs-5" id="font">
                            As a Backend developer i have experience in Django and Javascript (a little bit). I also have some experience in computer vision .
                        </p>
                    </div>
                </article>
            </div>
        )
    }
}

export default Service;
